import { DangerConfirmDialog } from "@/routes/admin/DangerConfirmDialog";

// Story 16.7 AC15 — the manual rescue for FR39's last arrow.
//
// Its own file rather than a third export beside Disable/Reactivate: those two
// are one control and its inverse over `authz.users.blocked_at`, and this one is
// a different subject entirely — it finishes a PAYMENT that already succeeded.
//
// The must-read names the ORDER, because the two failure directions on this
// screen are opposite. An admin who thinks this is "reactivate for paid users"
// will reach for it on a blocked account (ADMIN-018 refuses); an admin who
// thinks it grants access will reach for it on an unpaid one (ADMIN-017
// refuses). Saying "the payment already went through, this only finishes what it
// started" pre-empts both, and it is true — the server checks the money.
//
// It also names WHEN access lands, because the seam is a token rotation and the
// admin is the one who will be asked (review [CR-03]). The command writes
// `authz.users.is_active` and burns no session, so a clinician who signs in
// after this is admitted immediately, while an access token minted BEFORE the
// flip keeps answering 403 until the SPA's next silent refresh — seconds to
// minutes, with no re-login. Both halves are said, because an admin who
// promises the current tab works is wrong and an admin who tells them to log
// out again is inventing work.

export const ENABLE_PAID_ACCOUNT_MUST_READ =
  "The payment on this account already went through; this only finishes the activation it should have triggered. They can sign in and start calibration straight away; if they are already signed in, access appears on its own within a few minutes without logging out. Their subscription period starts when calibration completes.";

export interface EnablePaidAccountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userName: string;
  isPending: boolean;
  onConfirm: () => void;
}

export function EnablePaidAccountDialog({
  open,
  onOpenChange,
  userName,
  isPending,
  onConfirm,
}: EnablePaidAccountDialogProps) {
  return (
    <DangerConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Enable paid account"
      description={`${userName} will be able to sign in and begin calibration.`}
      mustRead={ENABLE_PAID_ACCOUNT_MUST_READ}
      mustReadVariant="info"
      // Granting the access a payment already bought is not destructive.
      confirmVariant="primary"
      confirmLabel="Enable account"
      pendingLabel="Enabling…"
      isPending={isPending}
      onConfirm={onConfirm}
    />
  );
}
